module.exports = __webpack_public_path__ + "7c27936a9703f02169b198e60f7673a0.png";